module.exports = __webpack_public_path__ + "img/mob4.780ffc54.jpg";;
if (typeof window !== 'undefined') {
(window.__IMAGE_SIZES__ || (window.__IMAGE_SIZES__ = {}))[module.exports] = {"width":425,"height":454,"variants":[]};
}